export default "/images/vendor/flag-icon-css/flags/1x1/un.svg?59939c4b1077f359a254002a9661456b";